import { cn } from '../../lib/utils.ts';
import { pillDotClass, pillToneClass } from './pill-tone.ts';

export type StateChipTone = 'ready' | 'check' | 'neutral';



/**
 * Zustands-Chip (Ticket 1.284 Nacharbeit, Vorbild Slack/Linear-Status): Pille im Ton des Zustands (Ton-Vertrag, Story 26.17) mit Statuspunkt und Wort
 * („da seit 08:00“, „in Pause seit 12:00“, „nicht da“). Der Punkt ist nur Zusatz zum Wort (nie Farbe allein) und
 * bewegt sich nicht (EK5: keine Dauer-Animation).
 */
export function StateChip({ tone, children, testId, className }: { tone: StateChipTone; children: string; testId?: string; className?: string }) {
  return (
    <span
      data-state-chip=""
      data-tone={tone}
      data-testid={testId}
      className={cn('inline-flex h-7 flex-none items-center gap-space-2 rounded-full px-space-3 type-meta font-medium whitespace-nowrap', pillToneClass(tone), className)}
    >
      <span aria-hidden data-state-dot="" className={cn('size-space-2 flex-none rounded-full', pillDotClass(tone))} />
      {children}
    </span>
  );
}
